import { alpha, Box } from "@mui/system";
import { Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export function Clock() {
  const [now, setNow] = useState<Date | null>(null);
  const theme = useTheme();

  useEffect(() => {
    const updateTime = () => setNow(new Date());
    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  if (!now) {
    return null;
  }

  return (
    <Box
      sx={{
        alignContent: "center",
        position: "relative",
        display: "inline-flex",

        "&:before": {
          position: "absolute",
          left: 0,
          bottom: 0,
          height: 5,
          width: `${now.getSeconds() * 1.66}%`,
          background: alpha(theme.palette.common.white, 0.5),
          content: '""',
          borderRadius: theme.shape.borderRadius / 2,
        },
      }}
    >
      <Typography variant="h1" color="white">
        <strong>
          {now.getHours().toString().padStart(2, "0")}:
          {now.getMinutes().toString().padStart(2, "0")}
        </strong>
      </Typography>
    </Box>
  );
}
